import {BaseModel} from './BaseModel';
import {Category} from './Category';
import {DatabaseFile} from './File';
import {Season} from './Season';


export class Podcast extends BaseModel {
  title!: string;
  imageId!: string;
  imageLargeId!: string;
  kind!: PodcastKind;
  type!: PodcastType;
  isPublished!: boolean;
  isDraft!: boolean;
  validFrom!: string;
  validTo!: string;
  publishedAt!: string;
  description!: string;
  externalSourceLink!: string;
  externalImageLink!: string;
  /** Source/original content language retained for compatibility. */
  language!: string;
  /** Source metadata locale returned by the multilingual API. */
  sourceLocale?: string | null;
  /** Metadata locale actually resolved for this response. */
  resolvedLocale?: string | null;
  /** True when the requested preference fell back to another locale. */
  isLocaleFallback?: boolean | null;
  /** Resolution source such as explicit, user, header, tenant or source. */
  localeResolutionSource?: string | null;
  /** Published metadata locales available to listeners, including source. */
  availableLocales?: string[];
  copyright!: string;
  isExplicit!: boolean;
  author!: string;
  isCompleted!: boolean;
  country!: string;
  keywords: string[] = [];
  image!: DatabaseFile;
  imageLarge!: DatabaseFile;
  seasons: Season[] = [];
  categories: Category[] = [];
  subtitle!: string;
  fullEpisodeCount!: number;
}

export enum PodcastKind {
  Episodic = 'Episodic',
  Serial = 'Serial',
}

export enum PodcastType {
  Internal = 'Internal',
  ExternalMixedSources = 'ExternalMixedSources',
  ExternalSingleSource = 'ExternalSingleSource',
  InternalAndPublic = "InternalAndPublic"
}

export class PodcastCreateDto {
  title!: string;
}

export class PodcastUpdateDto {
  title!: string;
}
